interface Props {
  onChiffre: (c: string) => void;
  onEffacer: () => void;
  onRetour: () => void;
  desactive?: boolean;
}

/**
 * Pave numerique maison plutot qu'un <input type="tel">.
 *
 * Le clavier systeme d'iOS mange la moitie de l'ecran, pousse la mise en page
 * et se ferme au mauvais moment. Ici les touches font 72 px de haut, tiennent
 * dans le bas de l'ecran, et restent atteignables au pouce d'une seule main.
 */
export function PaveNumerique({ onChiffre, onEffacer, onRetour, desactive }: Props) {
  const touches = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];

  return (
    <div className="pave">
      {touches.map((t) => (
        <button key={t} type="button" onClick={() => onChiffre(t)} disabled={desactive}>
          {t}
        </button>
      ))}
      <button type="button" className="action" onClick={onRetour} disabled={desactive}>
        Retour
      </button>
      <button type="button" onClick={() => onChiffre('0')} disabled={desactive}>
        0
      </button>
      <button
        type="button"
        className="action"
        onClick={onEffacer}
        disabled={desactive}
        aria-label="Effacer le dernier chiffre"
      >
        Effacer
      </button>
    </div>
  );
}
